/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_New_TitleInputs */

const en_admin_external_booking_new_title = /** @type {(inputs: Admin_External_Booking_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create External Booking`)
};

const de_admin_external_booking_new_title = /** @type {(inputs: Admin_External_Booking_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe Buchung machen`)
};

const es_admin_external_booking_new_title = /** @type {(inputs: Admin_External_Booking_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear reserva externa`)
};

const fr_admin_external_booking_new_title = /** @type {(inputs: Admin_External_Booking_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer une réservation externe`)
};

/** @type {(inputs: Admin_External_Booking_New_TitleInputs) => LocalizedString} */
const it_admin_external_booking_new_title = en_admin_external_booking_new_title;

/** @type {(inputs: Admin_External_Booking_New_TitleInputs) => LocalizedString} */
const pt_br2_admin_external_booking_new_title = en_admin_external_booking_new_title;

/** @type {(inputs: Admin_External_Booking_New_TitleInputs) => LocalizedString} */
const pl_admin_external_booking_new_title = en_admin_external_booking_new_title;

/** @type {(inputs: Admin_External_Booking_New_TitleInputs) => LocalizedString} */
const hu_admin_external_booking_new_title = en_admin_external_booking_new_title;

/** @type {(inputs: Admin_External_Booking_New_TitleInputs) => LocalizedString} */
const ro_admin_external_booking_new_title = en_admin_external_booking_new_title;

/**
* | output |
* | --- |
* | "Create External Booking" |
*
* @param {Admin_External_Booking_New_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_new_title = /** @type {((inputs?: Admin_External_Booking_New_TitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_New_TitleInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_new_title(inputs)
	if (locale === "de") return de_admin_external_booking_new_title(inputs)
	if (locale === "es") return es_admin_external_booking_new_title(inputs)
	if (locale === "fr") return fr_admin_external_booking_new_title(inputs)
	if (locale === "it") return it_admin_external_booking_new_title(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_new_title(inputs)
	if (locale === "pl") return pl_admin_external_booking_new_title(inputs)
	if (locale === "hu") return hu_admin_external_booking_new_title(inputs)
	return ro_admin_external_booking_new_title(inputs)
});
export { admin_external_booking_new_title as "admin.external_booking_new.title" }